import * as React from 'react';
import { st, classes } from './CoreDropdownContent.st.css';
import { CoreDropdownOption } from '../CoreDropdownOption';
const NOT_HOVERED_INDEX = -1;
/**
 * DropdownContent
 */
export class CoreDropdownContent extends React.PureComponent {
    constructor(props) {
        super(props);
        this.optionsContainerRef = null;
        this.mouseCoords = { screenX: -1, screenY: -1 };
        this.state = { hoveredIndex: NOT_HOVERED_INDEX };
        this.onMouseMove = this.onMouseMove.bind(this);
        this.onMouseDown = this.onMouseDown.bind(this);
        this.onOptionHover = this.onOptionHover.bind(this);
    }
    componentDidMount() {
        if (this.props.selectedIds.length) {
            const selectedIndex = this.props.options.findIndex((option) => option.id === this.props.selectedIds[0]);
            if (selectedIndex > -1) {
                const selectedOption = this.optionsContainerRef.childNodes[selectedIndex];
                const parentRect = this.optionsContainerRef.getBoundingClientRect();
                const selectedRect = selectedOption.getBoundingClientRect();
                if (selectedRect.bottom > parentRect.bottom) {
                    this.optionsContainerRef.scrollTop = Math.min(selectedOption.offsetTop +
                        selectedOption.clientHeight / 2 -
                        this.optionsContainerRef.offsetHeight / 2, this.optionsContainerRef.scrollHeight);
                }
                this.setHoveredIndex(selectedIndex);
            }
        }
    }
    setHoveredIndex(index) {
        if (this.state.hoveredIndex !== index) {
            this.setState({
                hoveredIndex: index,
            }, this.onOptionHover);
        }
    }
    onOptionHover() {
        if (this.props.onOptionHover) {
            this.props.onOptionHover(this.getSelectedOption());
        }
    }
    isValidOptionForSelection(option) {
        return option.isSelectable && !option.isDisabled;
    }
    hoverNextItem(interval) {
        const { options } = this.props;
        if (!options.find(this.isValidOptionForSelection)) {
            return;
        }
        let { hoveredIndex } = this.state;
        // eslint-disable-next-line no-constant-condition
        while (true) {
            hoveredIndex += interval;
            if (hoveredIndex === options.length) {
                hoveredIndex = 0;
            }
            else if (hoveredIndex < 0) {
                hoveredIndex = options.length - 1;
            }
            if (this.isValidOptionForSelection(options[hoveredIndex])) {
                break;
            }
        }
        if (this.optionsContainerRef) {
            const hoveredOption = this.optionsContainerRef.childNodes[hoveredIndex];
            const hoveredOptionHeight = hoveredOption.offsetHeight;
            const hoveredOptionTop = hoveredOption.offsetTop - 1;
            const { scrollTop: optionsContainerScrollTop, clientHeight: optionsContainerClientHeight, } = this.optionsContainerRef;
            // If hovered option is not visible
            if (!(optionsContainerScrollTop <= hoveredOptionTop &&
                optionsContainerScrollTop + optionsContainerClientHeight >
                    hoveredOptionTop + hoveredOptionHeight)) {
                if (this.optionsContainerRef.scrollTop < hoveredOptionTop) {
                    this.optionsContainerRef.scrollTop =
                        hoveredOptionHeight +
                            hoveredOptionTop -
                            optionsContainerClientHeight;
                }
                else {
                    this.optionsContainerRef.scrollTop = hoveredOptionTop;
                }
            }
        }
        this.setHoveredIndex(hoveredIndex);
    }
    getOptionDOMid(option) {
        const optionsContainerId = this.props.optionsContainerId;
        return optionsContainerId
            ? `${optionsContainerId}_option-${option.id}`
            : null;
    }
    getSelectedOption() {
        const { options } = this.props;
        const { hoveredIndex } = this.state;
        const isValidIndex = hoveredIndex >= 0 && hoveredIndex < options.length;
        return isValidIndex
            ? {
                ...options[hoveredIndex],
                _DOMid: this.getOptionDOMid(options[hoveredIndex]),
            }
            : null;
    }
    onKeyDown(eventKey, evt) {
        switch (eventKey) {
            case 'ArrowUp': {
                evt.preventDefault();
                return this.hoverNextItem(-1);
            }
            case 'ArrowDown': {
                evt.preventDefault();
                return this.hoverNextItem(1);
            }
            case 'ArrowLeft':
            case 'ArrowRight': {
                return;
            }
            default:
                this.setHoveredIndex(NOT_HOVERED_INDEX);
        }
    }
    onMouseMove(evt) {
        this.mouseCoords.screenX = evt.screenX;
        this.mouseCoords.screenY = evt.screenY;
    }
    onMouseDown(e) {
        const { onMouseDown } = this.props;
        onMouseDown && onMouseDown(e);
    }
    onMouseEnter(evt, index) {
        if (this.mouseCoords.screenX !== evt.screenX ||
            this.mouseCoords.screenY !== evt.screenY) {
            this.setHoveredIndex(index);
        }
    }
    render() {
        const { fixedHeader, fixedFooter, options, selectedIds, onOptionClick, optionsContainerId, className, } = this.props;
        const { hoveredIndex } = this.state;
        return (React.createElement("div", { className: st(classes.root, className), "data-hook": this.props['data-hook'], onMouseMove: this.onMouseMove, onMouseDown: this.onMouseDown },
            fixedHeader,
            React.createElement("div", { role: "menu", className: classes.optionsContainer, id: optionsContainerId, ref: (optionsContainer) => (this.optionsContainerRef = optionsContainer) }, (options || []).map((option, index) => (React.createElement(CoreDropdownOption, { className: classes.dropdownOption, dataHook: "option", key: option.id, id: this.getOptionDOMid(option), option: option, isHovered: hoveredIndex === index, isSelected: (selectedIds || []).includes(option.id), onClickHandler: this.isValidOptionForSelection(option)
                    ? () => onOptionClick(option)
                    : undefined, onMouseEnterHandler: this.isValidOptionForSelection(option)
                    ? (evt) => this.onMouseEnter(evt, index)
                    : undefined, onMouseLeaveHandler: () => {
                    this.setHoveredIndex(NOT_HOVERED_INDEX);
                } })))),
            fixedFooter));
    }
}
CoreDropdownContent.displayName = 'CoreDropdownContent';
//# sourceMappingURL=CoreDropdownContent.js.map